import { Button } from "@/components/ui/button";
import type { StockScannerEvent } from "@/components/widgets/Markets/types";
import { cn } from "@/lib/utils";
import { stockScannerEventConfig } from "../stockScannerConfig";

export const StockScannerButtonGroup = ({
	title,
	events = [],
	activeEvent,
	onButtonClick,
	className,
}: {
	title: string;
	events: StockScannerEvent[];
	activeEvent: StockScannerEvent;
	onButtonClick: (eventValue: StockScannerEvent) => void;
	className?: string;
}) => {
	return (
		<div className={className}>
			<h4 className="text-base text-accent-foreground font-bold p-0.5 text-center">
				{title}
			</h4>
			<div className="flex gap-x-2 flex-wrap">
				{events?.map((eventKey) => {
					const config = stockScannerEventConfig[eventKey];
					const isActive = activeEvent === eventKey;

					if (!config) return null;

					return (
						<Button
							key={eventKey}
							variant="secondary"
							onClick={() => onButtonClick(eventKey)}
							aria-pressed={isActive}
							aria-label={`Select ${config?.label} event`}
							className={cn(
								"!p-0.5 h-fit bg-transparent hover:bg-transparent hover:text-gold",
								{
									"text-gold": isActive,
								},
							)}
						>
							{config?.label}
						</Button>
					);
				})}
			</div>
		</div>
	);
};
